exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".voucher-list{min-height:200px;padding:2rem}", ""]);

// exports
